import ActivityEditor from './activity_editor';
import Utils from '../utils';
import Vue from 'vue';
import flash from '../flash';

export default class CommentEditor extends ActivityEditor {
  getData() {
    this.data.options.provideRecordersInPicker = true;
    this.data.options.commentContext = true;
    return this.data;
  }

  build() {
    var that = this;
    this.vue = new Vue({
      el: this.container,
      template: `
      <div class="lp--activityEditorContainer ir-hide">
        <div class="public-comment-info">{{i18n('teacher_panel_public_comment_info')}}</div>
        <comment-editor ref="editor" :item="item" :user="user" :options="options" :type="type" :header="header" @recorderStateChanged="recorderStateChanged" @recordingDone="recordingDone" @updateContent="updateContent" :messageTypePickerExpanded="true"/>
        <div class="lp--commentEditorFooter">
          <div class="lp--activityEditorFooterProtected" v-if="options.supportPrivate">
            <label tabindex="0" v-on:keyup.enter="checkPrivate">
              <input tabindex="-1" type="checkbox" v-model="item.protected" />
              {{i18n('comment_private_message')}}
            </label>
          </div>
            <button type="submit" v-if="provideSave && !options.locked" class="lp--activityEditorSubmit" v-on:click="save">
              {{options.buttonText}}
            </button>        
        </div>
      </div>`,
      mounted: function () {
        this._cnt = this.item.body;
      },
      methods: {
        i18n: function (str) {
          return i18n.__(str);
        },
        recorderStateChanged: function (recorderIsDisplayed) {
          this.$set(this.$data.options, 'isRecording', !!recorderIsDisplayed);
        },
        blur: function () {
          if (this.$refs.editor) {
            this.$refs.editor.blur();
          }
        },
        recordingDone: function (ev) {
          ev.preventDefault();
          this.save(ev);
        },
        checkPrivate: (ev) => {
          $(ev.target).trigger('click');
        },
        save: function (ev) {
          $(ev.target).blur();
          let promise = Promise.resolve(false);
          if (this.options.isRecording) {
            promise = promise.then(() => {
              return this.$refs.editor.publishRecording();
            });
          }
          promise.then((recording) => {
            if (recording) {
              this.item.type = recording.source;
              this._cnt = recording.filename;
            }

            this.$emit('save', this.getItem());
          });
        },
        changeItem: function (itm) {
          this._cnt = '';
          this.$set(this.$data, 'item', itm);
        },
        reset: function () {
          this._cnt = '';
          if (this.$refs.editor) {
            this.$refs.editor.clear();
          }
        },
        updateContent: function (cnt) {
          this._cnt = cnt;
        },
        getItem: function () {
          if (this.item.type == 'file') {
            this.item.body = '';
          } else {
            this.item.body = this._cnt;
          }
          let data = Utils.extend({}, this.item);
          data.attachments = data.attachments.filter(function (att) {
            return att.id === undefined;
          });
          return data;
        },
      },
      data: function () {
        return that.getData();
      },
    });

    this.vue.$on('save', (item) => {
      if (!item.type && (!item.body || item.body == '' || item.body == '<p><br></p>')) {
        flash(i18n.__('comment_empty_error_message'), { ttl: 3000, type: 'status' });
      } else {
        this.eventSource.trigger('save', item);
      }
    });
  }
}
